import React from 'react';
import PropTypes from 'prop-types';

import { Divider } from '@eb/eds-divider';
import { HAS_WINDOW } from '@eb/feature-detection';

import { SearchPaginator } from '../SearchPaginator';

export class SearchFooterLegacy extends React.PureComponent {
    static propTypes = {
        handleGetPage: PropTypes.func.isRequired,
        currentPage: PropTypes.number,
        isNextDisabled: PropTypes.bool,
        firstPageUrl: PropTypes.string,
        lastPageUrl: PropTypes.string,
        pageCount: PropTypes.number,
        hasEventResults: PropTypes.bool,
        //eslint-disable-next-line
        trendingSearchData: PropTypes.object,
        //eslint-disable-next-line
        history: PropTypes.object,
        nextPageUrl: PropTypes.string,
        prevPageUrl: PropTypes.string,
    };

    _onGetPage = (pageNumber) => {
        const { handleGetPage, history } = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }

        handleGetPage(pageNumber, history);
    };

    render() {
        const {
            currentPage,
            isNextDisabled,
            nextPageUrl,
            prevPageUrl,
            firstPageUrl,
            pageCount,
            lastPageUrl,
            hasEventResults,
        } = this.props;

        let searchFooter = null;

        if (hasEventResults) {
            searchFooter = (
                <div>
                    <div className="destination-search-footer eds-l-mar-bot-10 eds-l-mar-top-10 eds-l-mar-left-3">
                        <SearchPaginator
                            currentPage={currentPage}
                            handleGetPage={this._onGetPage}
                            isNextDisabled={isNextDisabled}
                            nextUrl={nextPageUrl}
                            prevUrl={prevPageUrl}
                            firstPageUrl={firstPageUrl}
                            lastPageUrl={lastPageUrl}
                            pageCount={pageCount}
                        />
                    </div>
                    <div className="eds-l-pad-hor-3">
                        <Divider color="grey-300" />
                    </div>
                </div>
            );
        }

        return <footer className="search-footer">{searchFooter}</footer>;
    }
}
